
<template>
    
        <mars-view v-if="datas && datas.case_title" class="module-card"><mars-view v-if="datas.case_title" class="card-title">
        {{ datas.case_title }}
    </mars-view><mars-view v-if="datas.case_result || datas.case_domain" class="card-tag"><mars-view v-if="datas.case_result" class="card-result-tag" :class="isVip ? 'card-result-tag-vip' : ''"><mars-view class="card-result-tag-icon"></mars-view>{{ datas.case_result }}
        </mars-view><mars-view v-if="datas.case_domain" class="card-area-tag">
            {{ datas.case_domain }}
        </mars-view></mars-view><mars-view v-if="contentValue" class="card-content">
        {{ contentValue }}
        <mars-view class="show-all-btn">...全文</mars-view></mars-view><mars-view v-if="datas.case_time" class="card-time"><mars-text class="c-gap-right">
            {{ datas.case_time }}
        </mars-text></mars-view></mars-view>
    
</template>

<script>
export default {
  components: {},
  computed: {
    contentValue() {
      const {
        case_content
      } = this.datas;
      return case_content && case_content.replace(/<.*?>/g, '').replace(/&nbsp;/g, '') || '';
    }
  },
  props: {
    isVip: {
      type: String,
      default: ''
    },
    datas: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style scoped>
.tag {
  display: inline-block;
  border: 1px solid #eee;
  border-radius: 5px;
  font-size: 14px;
  color: #999;
  text-align: center;
  line-height: 28px;
  height: 28px;
  padding: 0 10px;
  margin-right: 8px;
  margin: 8px 8px 0 0;
}
.card-title {
  font-family: PingFangSC-Medium;
  font-size: 0.17rem;
  color: #1e1f24;
  line-height: 0.26rem;
  font-weight: 500;
  margin-bottom: 0.07rem;
}
.card-tag {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0.09rem;
}
.card-tag .card-result-tag {
  height: 0.16rem;
  border: 1px solid rgba(0, 85, 255, 0.5);
  box-sizing: border-box;
  border-radius: 0.04rem;
  display: flex;
  align-items: center;
  padding: 0.03rem 0.04rem;
  font-family: PingFangSC-Medium;
  font-size: 0.11rem;
  color: #05f;
  margin-right: 0.06rem;
}
.card-tag .card-result-tag .card-result-tag-icon {
  width: 0.11rem;
  height: 0.11rem;
  border-radius: 50%;
  margin-right: 3px;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/lawyer-home/no-vip-case.png') no-repeat;
  background-size: 100% 100%;
}
.card-tag .card-result-tag-vip {
  height: 0.16rem;
  border: 1px solid #fed9b9;
  box-sizing: border-box;
  border-radius: 0.04rem;
  display: flex;
  align-items: center;
  padding: 0.04rem 0.04rem 0.03rem;
  font-family: PingFangSC-Medium;
  font-size: 0.11rem;
  color: #401611;
  margin-right: 0.06rem;
}
.card-tag .card-result-tag-vip .card-result-tag-icon {
  width: 0.11rem;
  height: 0.11rem;
  border-radius: 50%;
  margin-right: 3px;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/lawyer-home/vip-case.png') no-repeat;
  background-size: 100% 100%;
}
.card-tag .card-area-tag {
  height: 0.16rem;
  border: 1px solid rgba(115, 125, 153, 0.4);
  box-sizing: border-box;
  border-radius: 0.04rem;
  display: flex;
  align-items: center;
  padding: 0.04rem 0.04rem 0.03rem;
  font-family: PingFangSC-Medium;
  font-size: 0.11rem;
  line-height: 1;
  color: #737d99;
}
.card-content {
  font-family: PingFangSC-Regular;
  font-size: 0.15rem;
  color: #50525c;
  letter-spacing: 0;
  line-height: 0.25rem;
  display: -webkit-box;
  overflow: hidden;
  margin-bottom: 0.05rem;
  white-space: normal;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  position: relative;
  text-align: justify;
}
.card-content .show-all-btn {
  color: #222;
  font-size: 0.15rem;
  font-weight: 500;
  text-align: right;
  background-color: #fff;
  position: absolute;
  right: 0;
  bottom: -0.01rem;
}
.card-content .show-all-btn::before {
  content: "";
  width: 60px;
  height: 100%;
  position: absolute;
  left: -60px;
  top: 0;
  background: linear-gradient(to right, rgba(255, 255, 255, 0), #ffffff);
}
.card-time {
  font-family: PingFangSC-Regular;
  font-size: 0.14rem;
  color: #848691;
  line-height: 1;
  padding-top: 0.04rem;
}

</style>
